import { useEffect } from 'react';
import { AgeGroup } from 'mcsclient/models';
import { ApiCallResultStatus } from 'store/apiCallResultStatus';
import { useAppDispatch, useAppSelector } from 'store/hooks';

import { getUserProfileAsync } from './userProfileSlice';

export const useUserProfile = () => {
  const dispatch = useAppDispatch();
  const userData = useAppSelector((state) => state.userProfile);
  const shouldLoadUserProfile = userData.userProfileLoadingStatus === ApiCallResultStatus.DEFAULT;

  useEffect(() => {
    if (shouldLoadUserProfile) {
      void dispatch(getUserProfileAsync());
    }
  }, [dispatch, shouldLoadUserProfile]);

  return {
    ...userData,
    isAllowedToManageInfo: (['Undefined', 'NotAdult' /* teenager but not child */, 'Adult'] as (AgeGroup | undefined)[]).includes(
      userData.userProfile.ageGroup
    ),
    isAllowedToAddSSN: (['Undefined', 'Adult'] as (AgeGroup | undefined)[]).includes(userData.userProfile.ageGroup),
  };
};
